import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const EMPATHIZE_WIRING: Wiring = {
  [EVENTS.InputArrowPressed]: [
    WIRES.empathizeArrowPress
  ],
  [EVENTS.InputBlur]: [
    WIRES.closeEmpathize,
    WIRES.setInputAsClean,
    WIRES.emitUserAcceptedQuery
  ],
  [EVENTS.InputClicked]: [
    WIRES.openEmpathize
  ],
  [EVENTS.InputEnterPressed]: [
    WIRES.changeQueryIfNotHighlightedEmpathizeItem,
    WIRES.selectHighlightedEmpathizeSuggestion,
    WIRES.blurSearchInput
  ],
  [EVENTS.InputEscapePressed]: [
    WIRES.closeEmpathize
  ],
  [EVENTS.InputFocused]: [
    WIRES.openEmpathize
  ],
  [EVENTS.SuggestionSelected]: [
    WIRES.queryOriginTopTermCategory,
    WIRES.empathizeElementSelected
  ],
  [EVENTS.PopularSearchSelected]: [
    WIRES.queryOriginPopularSearches,
    WIRES.empathizeElementSelected
  ],
  [EVENTS.EmpathizeElementSelected]: [
    WIRES.clearFilters,
    WIRES.suggestionSelected,
    WIRES.getTermSuggestions,
    WIRES.getIdentifierSuggestions,
    WIRES.blurSearchInput
  ],
  [EVENTS.EmpathizeSuccess]: [
    WIRES.saveEmpathizeResponse
  ],
  [EVENTS.NextQuerySuggestionSelected]: [
    WIRES.queryOriginNextQuerySuggestion,
    WIRES.emitApplyNextQuery,
    WIRES.blurSearchInput
  ],
  [EVENTS.RedirectionClicked]: [
    WIRES.redirection
  ]
};
